import { CustomImage, Text } from '@src/components';
import iconEdit from '@src/assets/icons/icon-edit.svg';
import iconBin from '@src/assets/icons/icon-bin.svg';
import PropTypes from 'prop-types';

const UpdateMenu = ({ record, handleEdit, setSelectedRowDelete, setSelectedRecord }) => {
  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '10px',
      boxShadow: '0 0 4px 0 rgba(96, 97, 112, 0.16), 0 0 1px 0 rgba(40, 41, 61, 0.04), 0 4px 4px 0 rgba(0, 0, 0, 0.07)',
      padding: '16px 0 16px 16px',
      width: '162px',
      fontFamily: 'Ubuntu',
      color: '#0f172a',
      fontSize: '14px',
      fontWeight: 'normal'
    }}>
      <button onClick={() => handleEdit(record)} style={{ display: 'flex', gap: '12px', marginBottom: '20px', background: 'none', border: 'none', width: '100%' }}>
        <CustomImage src={iconEdit} />
        <div>
          <Text t="edit2" />
        </div>
      </button>
      <button onClick={() => { setSelectedRowDelete(true); setSelectedRecord(record); }} style={{ display: 'flex', gap: '12px', background: 'none', border: 'none', width: '100%' }}>
        <CustomImage src={iconBin} />
        <div>
          <Text t="delete2" />
        </div>
      </button>
    </div>
  );
};

export default UpdateMenu;

UpdateMenu.propTypes = {
  record: PropTypes.any,
  handleEdit: PropTypes.func,
  setSelectedRowDelete: PropTypes.func,
  setSelectedRecord: PropTypes.func,
};